module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"subtitle":"Page not found","description":"Our website doesn\u0027t have a page that matches the requested address.<br>How about starting looking for the correct page from the home?","home_link":"Home"},"pt-BR":{"subtitle":"Acesso negado","description":"Você não possui acesso a esta página. Por favor, retorne à homepage.","home_link":"Home"}}')
  delete Component.options._Ctor
}
